<pbc-sorter [config]="ErforderlichesDokumentsSorterConfig" [sorter]="erforderlichesDokuments.sorter$ | async" (sorterChange)="erforderlichesDokuments.sorter$.next($event)"></pbc-sorter>
